import { useEffect, useRef } from 'react'

// --- HOW TO USE ---

// --- Pass in the HTML element when calling the hook, using HTMLUListElement here as we're passing the ref onto a <ul> ---
// --- Pass in the callback to fire for useOnClickOutside ---
// const ref = useOnClickOutside<HTMLUListElement>(() => {
//   clearSuggestions()
// })
// <ul className="absolute left-0 top-12 w-full border border-neutral-400 bg-white" ref={ref}>
// {data.map((suggestion) => {
//   const {
//     place_id,
//     structured_formatting: { main_text, secondary_text },
//   } = suggestion
//
//   return (
//     <ul ref={ref}>
//       {children}
//     </ul>
//   )

export const useOnClickOutside = <T extends HTMLElement>(callback: (event: MouseEvent) => void) => {
  const ref = useRef<T>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [callback])

  return ref
}
